import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
// Components
import FullButton from "../Buttons/FullButton";
import PdfIcon from "../Elements/PdfIcon";
// Assets
import HeaderImage from "../../assets/img/header-img.png";

const features = [
  "Touchscreen, user-friendly interface",
  "Automatic sample detection & collision protection",
];

export default function Header() {
  return (
    <Wrapper id="home" className="container flexSpaceCenter">
      <LeftSide className="flexCenter">
        <div>
          <Kicker className="font13 extraBold purpleColor">
            Point-of-Care Diagnostics
          </Kicker>
          <h1 className="font40 extraBold">
            Leading the Way in Diagnostic Excellence.
          </h1>
          <HeaderP className="font10 semiBold">
            Finechek Africa Systems endeavors to offer her client a comprehensive
            range of diagnostic products.<br />
            Introducing the all-new FineChek BCA-100. Experience cutting-edge technology,
            exclusive features, and unmatched performance like never before!
          </HeaderP>
          <BtnRow className="flexNullCenter">
            <a
            href="/products/Finechek BCA 100/Finecheck BCA 100 bronchure.pdf"
            target="_blank"
            rel="noopener noreferrer">
              <FullButton title="Finechek BCA-100 Brochure" icon={<PdfIcon />} />
            </a>
            <SecondaryBtnWrapper>
              <Link to="/contact">
                <FullButton title="Contact Us" border />
              </Link>
            </SecondaryBtnWrapper>
          </BtnRow>
          <FeatureList>
            {features.map((feature) => (
              <li key={feature} className="font13">
                <CheckIcon />
                {feature}
              </li>
            ))}
          </FeatureList>
        </div>
      </LeftSide>
      <RightSide>
        <ImageWrapper>
          <Blob />
          <Img
          className="radius8"
          src={HeaderImage}
          alt="Finecheck BCA-100"
          />
        </ImageWrapper>
      </RightSide>
    </Wrapper>
  );
}

function CheckIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="rgb(119, 31, 115)" />
      <path d="M7 12.5L10.2 15.5L17 8.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  min-height: 840px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
const LeftSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 2;
    margin: 50px 0;
    text-align: center;
  }
  @media (max-width: 560px) {
    margin: 80px 0 50px 0;
  }
`;
const RightSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
    margin-top: 30px;
  }
`;
const Kicker = styled.div`
  display: inline-block;
  padding: 6px 14px;
  border-radius: 20px;
  background-color: rgba(119, 31, 115, 0.1);
  margin-bottom: 20px;
`;
const HeaderP = styled.div`
  max-width: 470px;
  padding: 15px 0 30px 0;
  line-height: 1.5rem;
  @media (max-width: 960px) {
    padding: 15px 0 30px 0;
    text-align: center;
    max-width: 100%;
  }
`;
const BtnRow = styled.div`
  gap: 15px;
  @media (max-width: 960px) {
    justify-content: center;
  }
  @media (max-width: 560px) {
    flex-direction: column;
    align-items: stretch;
  }
`;
const SecondaryBtnWrapper = styled.div`
  min-width: 160px;
`;
const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 30px 0 0 0;
  li {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    color: #707070;
  }
  svg {
    flex-shrink: 0;
  }
  @media (max-width: 960px) {
    li {
      justify-content: center;
    }
  }
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 9;
  @media (max-width: 960px) {
    width: 100%;
    justify-content: center;
  }
`;
const Img = styled.img`
  position: relative;
  z-index: 2;
  @media (max-width: 560px) {
    width: 80%;
    height: auto;
  }
`;
const Blob = styled.div`
  position: absolute;
  z-index: 1;
  top: 50%;
  right: 10%;
  width: 420px;
  height: 420px;
  max-width: 80%;
  transform: translateY(-50%);
  border-radius: 50%;
  background: radial-gradient(circle, rgba(119, 31, 115, 0.12) 0%, rgba(119, 31, 115, 0) 70%);
`;
